import { useState,useEffect,useRef } from 'react';
import { Form, Input,TextArea,Checkbox,Space,Cascader,Button,Popup,SearchBar,List,ErrorBlock,SpinLoading,Modal,Toast,Grid } from 'antd-mobile';
import { getTianYanCha,addCusClue } from "../../apis/commonApi";
import { cityJson } from './data';
import { RightOutline } from 'antd-mobile-icons';
import { useLocation } from "react-router";
import "./index.scss";

const ProductList = ['液氧','食品氮','液氮','液氩','医用氧','高纯氧','液态二氧化碳'];
const CheckboxStyle = { '--icon-size': '18px','--font-size': '14px','--gap': '12px','--border-radius': '3px','--background-color':'red'}
const validateArea = (_, value) => {
    if (!value || !value.length) {
      return Promise.reject(new Error('请选择所在地区'))
    }
    if (!value[0]) {
      return Promise.reject(new Error('请选择所在地的省份或直辖市'))
    }
    if (!value[1]) {
      return Promise.reject(new Error('请选择所在地的市'))
    }
    return Promise.resolve()
  }


const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const Sfa = () => {
  const [popShow, setPopShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [form] = Form.useForm();
  const load = useRef(false);
  const { search } = useLocation();
  const cusName = Form.useWatch('cusName', form)

  const debouncedSearchValue = useDebounce(searchValue, 500);

  const getData = (item) => {
    setPopShow(false)
    form.setFieldsValue({
      tax: item?.creditCode || '',
      clueName: item?.name || '',
      cusName: item?.name || '',
      legalRepresentative: item?.legalPersonName || '',
      incorporationDate: (item?.estiblishTime || '').substr(0,10) || ''
    })
    
  }

  const handleSearch = (word) => {
    setLoading(true)
    getTianYanCha({pageSize:10,pageNum:1,word}).then(res=>{
      setSearchResults(res?.result?.items || []);
    }).catch(()=>{
      setSearchResults([])
    }).finally(()=>{
      setLoading(false)
    })
  }

  const setArea = (e) => {
    form.setFieldValue('area', e)
    form.setFields([
      {
        name: 'area',
        errors: [] 
      }
    ])
  }

  const onFinish = (value) => {
    if(load.current) return
    load.current = true;
    setBtnLoading(true);
    const query = new URLSearchParams(search);
    let province = cityJson.find(v=>v.value == value.area[0]);
    let city = (province?.children || []).find(v=>v.value == value.area[1]);
    let county = (city?.children || []).find(v=>v.value == value.area[2]);
    let params = {
      clueSource:query.get("clueSource"),
      poolId:query.get("poolId"),
      userCode:query.get("userCode"),
      userName:query.get("userName"),
      contactCity:city?.label || '',
      contactCounty:county?.label || '',
      contactProvince:province?.label || '',
      ...JSON.parse(JSON.stringify(value))
    }
    delete params.area
    params.intentionProductName = params.intentionProductName.join(',');
    let qs = '';
    for(let k in params){
      qs += (k+'='+params[k]+'&')
    }
    addCusClue(qs).then(res=>{
      Modal.alert({
        content: '信息提交成功',
        className:'sfa-modal'
      })
      form.resetFields()
    }).catch(()=>{
      Toast.show({
        icon: 'fail',
        content: '提交失败，请稍后重试',
      })
    }).finally(_=>{
      load.current = false
      setBtnLoading(false)
    })

  }

  useEffect(() => {
    if (debouncedSearchValue) {
      handleSearch(debouncedSearchValue);
    } else {
      setSearchResults([]);
    }
  }, [debouncedSearchValue]);

  return (
    <>
      <div className="sfa-contain">
        <div className='sfa-bac'>
          <img src="https://yd-crm-mini-prod-oss.oss-cn-shanghai.aliyuncs.com/file/sfa_top.png" alt="" />
          <div className='sfa-bac-text'>感谢您抽出几分钟时间填写以下内容！</div>
          <div className='sfa-form-top'></div>
        </div>
        <Form 
          layout='horizontal'
          mode='card' 
          className='sfa-form'
          onFinish={onFinish}
          form={form}
          footer={
          <Button loadingText='提交中' loading={btnLoading} type='submit' color='primary' className='sfa-submit-btn'>
            提交
          </Button>
        }
        >
          <Form.Item name="tax" hidden>
            <Input />
          </Form.Item>
           <Form.Item name="clueName" hidden>
            <Input />
          </Form.Item>
           <Form.Item name="legalRepresentative" hidden>
            <Input />
          </Form.Item>
           <Form.Item name="incorporationDate" hidden>
            <Input />
          </Form.Item>
          <Form.Item label='姓名' rules={[{ required: true, message: '姓名不能为空' }]} name="mainContactPerson" className='sfa-form-item'>
            <Input placeholder='请输入姓名' />
          </Form.Item>
          <Form.Item label='联系电话' rules={[{ required: true, message: '联系电话不能为空' }, { pattern: /^1[3-9]\d{9}$/,  message: '请输入正确的手机号码'}]}  name="mainContactTel" className='sfa-form-item'>
            <Input placeholder='请输入联系电话' type='number' />
          </Form.Item>
          <Form.Item name="cusName" rules={[{ required: true, message: '公司名称不能为空' }]} label='公司名称' className='sfa-form-item sfa-select-item'>
            <div className='select-contain' onClick={()=>{setPopShow(true)}}>
              <div className={cusName?'select-active':''}>{cusName || '请选择公司'}</div>
              <div className="select-contain-icon"><RightOutline /></div>
            </div>
          </Form.Item>
          <Form.Item name="area" rules={[{ required: true, validator:validateArea}]} label='所在地区' className='sfa-form-item sfa-select-item'>
            <Cascader
              options={cityJson}
              onConfirm={setArea}
            >
              {
                (items, actions) => {
                return (
                  <div className='select-contain' onClick={actions.open}>
                    <div className={(items && items.length)?'select-active':''}>{items.map(item => item?.label ?? '未选择').join('-') || '请选择城市'}</div>
                    <div className="select-contain-icon"><RightOutline /></div>
                  </div>
                )}
              }
            </Cascader>
          </Form.Item>
          <Form.Item label='详细地址' name="contactAddress" className='sfa-form-item sfa-text-item'>
            <TextArea
              placeholder='请输入地址'
              maxLength={100}
              rows={2}
            />
          </Form.Item>
          <Form.Item label='意向产品' rules={[{ required: true, message: '意向产品不能为空' }]}  name="intentionProductName" layout='vertical' className='sfa-form-item sfa-check-item'>
            <Checkbox.Group>
              <Grid columns={3} gap={8}>
                {ProductList.map((v,i)=><Grid.Item key={i}  span={i==6?3:1}><Checkbox style={CheckboxStyle} value={v}>{v}</Checkbox></Grid.Item>)}
              </Grid>
              {/* <Space wrap direction='horizontal'>
                {ProductList.map((v,i)=><Checkbox style={CheckboxStyle} key={i} value={v}>{v}</Checkbox>)}
              </Space> */}
            </Checkbox.Group> 
          </Form.Item>
          <Form.Item label='月均用量' name="monthQty" className='sfa-form-item'>
            <Input placeholder='请输入月均用量' />
          </Form.Item>
        </Form>
      </div>
      <Popup
        visible={popShow}
        onMaskClick={() => {
          setPopShow(false)
        }}
        onClose={() => {
          setPopShow(false)
        }}
        bodyStyle={{ height: '72vh',borderRadius: '8px 8px 0 0' }}
      >
        <div className='sfa-company'>
          <div className='sfa-company-head'>
             <SearchBar
              placeholder='请输入内容'
              onChange={(e) => {
                setSearchValue(e)}
              }
            />
          </div>
          <div className='sfa-company-content'>
            {(searchResults && searchResults.length)?
            <List>
              {searchResults.map(v=><List.Item onClick={()=>{getData(v)}} key={v?.id}>{v?.name || '---'}</List.Item>)}
            </List>:<ErrorBlock 
              style={{ padding: '64px 0' }}
              imageStyle={{ width: 128 }}
              status='empty'
              title='暂无数据'
              description=""
            />}
            {loading && <div className='sfa-loading'><SpinLoading color='primary' style={{ '--size': '68px' }} /></div>}
          </div>
        </div>
        
      </Popup>
    </>
  );
};

export default Sfa;